import { render, staticRenderFns } from "./TraktAuthorize.vue?vue&type=template&id=14a0d490&"
import script from "./TraktAuthorize.vue?vue&type=script&lang=js&"
export * from "./TraktAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./TraktAuthorize.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports